import React, { useEffect, useState } from 'react'
import {Box} from '@material-ui/core'
import LogoBancaSistema from '../../images/banca-sistema-logo.svg'
import Cookies from 'js-cookie'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiCard from '@mui/material/Card'
import { Button, CircularProgress } from '@material-ui/core'
import { styled } from '@mui/material/styles'
import { customTheme } from '../../styling'
import axiosInstance from '../../axios'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import SnackBar from '../../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../../constants'


const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}))

const SignInContainer = styled(Stack)(({ theme }) => ({
  backgroundColor:customTheme.colors.ui.white,
  height:'100vh',
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
  },
}))


const Login = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const { enqueueSnackbar } = SnackBar.Consumer()



  useEffect(() => {
    // Sempre limpar tokens ao entrar na tela de login
    localStorage.removeItem('access-token')
    Cookies.remove('refresh-token')

    const urlParams = new URLSearchParams(location.search)
    const token = urlParams.get('token')

    if (token) {
      handleLoginRequest(token)
        .then((res) => {
          setLoading(false)
          localStorage.setItem('access-token', res.access)
          Cookies.set('refresh-token', res.refresh)
          history.push('/')
        })
        .catch(error => {
          console.log('ERROR', error)
          enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
          history.push('/login')
        })
    } else {
      setLoading(false)
    }
  }, [location.search])
  
  const handleLoginRequest = async (token) => {
    const userCreds =  await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/session?token=${token}`)
    return userCreds?.data?.payload
    
  }

  return (
    <Box>
      {loading ? <Box style={{position:'absolute', top:'50%', left:'50%'}}><CircularProgress  size={40} /></Box>:
      <SignInContainer direction="column" style={{display:'flex', justifyContent: 'center' }} >
        <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '6vh', paddingBottom: 20 }}>
          <img src={LogoBancaSistema} style={{ height: '11vh'}} />
          <Card variant="outlined" style={{borderRadius: 15}}>
            <Typography
              component="h1"
              variant="h4"
              sx={{ width: '100%', textAlign:'center', fontSize: 'clamp(2rem, 10vw, 2.15rem)', marginBottom: 1}}
            >
              Accedi con Microsoft
            </Typography>
            <Box
              
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                gap:2,
              }}
            >
    
              
              <form method='get' action={`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/sign_in`}>
              <Button
                fullWidth
                variant="contained"
                color='primary'
                type="submit"
                // onClick={() => handleLogin()}
              >
                Accedi
              </Button>
              </form>
            </Box>
            
            
          </Card>
        </Box>
      </SignInContainer>
}
      
    </Box>
  )
}

export default Login